


































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
import UserService from '@/services/user.service';
import TipoEvaluacion from '@/models/evaluacion/tipoEvaluacion.model';
import BaseSelectComponent from '@/components/base/baseSelect/baseSelect.vue';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import Pregunta from '@/models/evaluacion/pregunta.model';
import { AnswerType } from '@/enums/AsnwerType';
import PreguntaOpcionRespuesta from '@/models/evaluacion/pregunta-opcion-respuesta';
@Component({
  components: {
    BaseSelectComponent
  }
})
export default class EvaluationTypeAdd extends GenericAdd<Pregunta> {
  active = false;
  researchCenters = [];
  userService: UserService = new UserService();
  loading: boolean = false;
  userSelected: any = null;
  opcionesRespuesta = [];
  preguntaOpcionRespuestaModel: PreguntaOpcionRespuesta = new PreguntaOpcionRespuesta();
  opcionRespuestaSelected: any = null;
  answerType = AnswerType;
  types = [
    {
      id: AnswerType.TEXTBOX,
      name: 'Comentario'
    },
    {
      id: AnswerType.CHECKBOX,
      name: 'Selección multiple'
    },
    {
      id: AnswerType.SELECT,
      name: 'Selección única'
    },
  ];

  constructor() {
    super();
    this.controller = "Pregunta";
    this.model = new Pregunta();
  }

  mounted() {
    this.model.tipoEvaluacionId = Number(this.$route.params.id); 
  }

  addOpcionRespuesta() {
    let preguntaModel: PreguntaOpcionRespuesta = new PreguntaOpcionRespuesta();
    preguntaModel.tipoRespuesta = this.opcionRespuestaSelected;
    preguntaModel.valorString = this.preguntaOpcionRespuestaModel.valorString;
    this.model.preguntaOpcionRespuestas.push(preguntaModel);
    this.preguntaOpcionRespuestaModel.valorString = null;
  } 

  removeAsnwer(i: any) {
    this.model.preguntaOpcionRespuestas.splice(i, 1);
  }

  get user() {
    return this.$store.state.user;
  }
}
